export const SET_TOKEN = '/authorization/token/set';
